<template>
  <div class="dbj-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="订单类型">
              <el-select v-model="searchForm.type" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option-group label="">
                  <el-option label="正单" :value="0" />
                  <el-option label="补单" :value="5" />
                </el-option-group>
                <el-option-group label="补单类型">
                  <el-option label="客改单" :value="1" />
                  <el-option label="增补单" :value="2" />
                  <el-option label="色板单" :value="3" />
                  <el-option label="售后单" :value="4" />
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="品牌">
              <el-select v-model="searchForm.brandId" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option v-for="brand in brandList" :key="brand.brand_id" :label="brand.brand_name" :value="brand.brand_id" />
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-printer" :loading="exportLoading" plain @click="exportExcel">导出Excel</el-button>
            </el-form-item>
            <el-form-item style="float: right">
              <el-button-group>
                <el-button :type="mark===8?'primary':''" size="small" @click="changeMark(8)">待报价</el-button>
                <el-button :type="mark===9?'primary':''" size="small" @click="changeMark(9)">已报价</el-button>
              </el-button-group>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  @row-click="openDetails"
                  style="width: 100%">
                  <el-table-column
                    label="订单号"
                    width="140"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.order_num}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="生产单号"
                    width="120"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{scope.row.product_num}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="经销商"
                    width="120"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span :style="scope.row.all_name && scope.row.all_name.indexOf('VIP') > -1 ? 'font-weight: bold; color: #389e0d; font-style: italic;' : ''">
                        {{ scope.row.all_name }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单类型"
                    width="110"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.mark===0">正单</span>
                      <span v-if="scope.row.mark===1">客改单</span>
                      <span v-if="scope.row.mark===2">增补单</span>
                      <span v-if="scope.row.mark===3">色板单</span>
                      <span v-if="scope.row.mark===4">售后单</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单性质"
                    width="110"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.nature===0">家装</span>
                      <span v-if="scope.row.nature===1">展厅</span>
                      <span v-if="scope.row.nature===2">工程</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="品牌"
                    width="130"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.brand_name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单确认时间"
                    width="170"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.affirm_time}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="详细地址"
                    min-width="200"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.address}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="状态"
                    width="120"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.status===8&&scope.row.type===6" type="danger">预付驳回</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.status===8&&scope.row.type!==6" type="warning">待报价</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.status===9">已报价</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    v-if="this.mark===8"
                    width="120"
                    fixed="right"
                    align="center"
                    label="操作">
                    <template slot-scope="scope">
                      <el-button size="mini" icon="el-icon-document-checked" @click.stop="offer(scope.row)">订单报价</el-button>
                    </template>
                  </el-table-column>
                  <el-table-column
                    v-if="this.mark===9"
                    width="240"
                    fixed="right"
                    align="center"
                    label="操作">
                    <template slot-scope="scope">
                      <el-button size="mini" icon="el-icon-edit" @click.stop="editOffer(scope.row)">订单改价</el-button>
                      <el-button size="mini" icon="el-icon-document" @click.stop="changeRecord(scope.row)">改价记录</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="订单报价"
      :visible.sync="editVisible"
      width="800px"
      top="10vh"
      :destroy-on-close="true"
      :close-on-click-modal="editForm.offerFileid===null||editForm.offerFileid===''||editForm.offerFileid===undefined"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="editForm" :model="editForm" :rules="editRules"  label-position="right" label-width="90px" size="small">
        <el-form-item label="操作订单" prop="ordername">
          <el-input v-model="editForm.ordername" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="拆单详情" prop="spitdetail">
          <el-card shadow="hover" style="font-size: 12px">
            <div>
              <span style="color:#99a9bf">拆单人员：</span>
              <span style="color:#606266">{{editForm.splitname}}</span>
              <span style="color:#99a9bf;margin-left: 20px">拆单时间：</span>
              <span style="color:#606266">{{editForm.splittime}}</span>
            </div>
            <div>
              <span style="color:#99a9bf">拆单结果：</span>
              <el-button type="text" @click="getMaterialDetail" icon="el-icon-document" title="点击查看拆单详情">{{editForm.splitfile}}</el-button>
              <el-divider direction="vertical"></el-divider>
              <el-button type="text" @click="downMaterial" icon="el-icon-download">下载生产料单</el-button>
            </div>
          </el-card>
        </el-form-item>
        <el-form-item label="报价书" prop="qid">
          <el-select v-model="editForm.qid" filterable style="width: 100%" placeholder="请选择"  multiple >
            <el-option
              v-for="item in quoteData"
              v-if="editForm.bid===item.bid||(editForm.bid===2&&item.bid===1)"
              :label="item.name"
              :value="item.qid">
              <el-tag size="mini" type="warning">{{ item.year }}年</el-tag>
              <span style="margin-left: 6px">{{ item.name }}</span>
            </el-option>
          </el-select>
<!--          <el-button type="text" @click="downQuote" icon="el-icon-download">下载报价书</el-button>-->
        </el-form-item>
        <el-form-item label="报价上传" prop="fileid">
          <SingleFile v-model="editForm.fileid" :key="fileLoad" :accept="'.xls'" :old="oldFile" :tip="'只能上传Excel，文件上传后请导入'" ></SingleFile>
        </el-form-item>
        <el-form-item label="报价解析" prop="offerFileid">
          <el-tag type="success" :disable-transitions="true" v-if="editForm.offerFileid!==null&&editForm.offerFileid!==''&&editForm.offerFileid!==undefined">报价单已解析</el-tag>
          <el-tag type="danger" :disable-transitions="true" v-if="(editForm.fileid===null||editForm.fileid===''||editForm.fileid===undefined)&&(editForm.offerFileid===null||editForm.offerFileid===''||editForm.offerFileid===undefined)">未上传报价单</el-tag>
          <el-tag type="warning" :disable-transitions="true" v-if="editForm.fileid!==null&&editForm.fileid!==''&&editForm.fileid!==undefined&&(editForm.offerFileid===null||editForm.offerFileid===''||editForm.offerFileid===undefined)">未解析报价单</el-tag>
          <el-popconfirm title="确认解析此报价单吗？" :key="importKey" placement="top" @onConfirm="importOffer" v-if="editForm.fileid!==null&&editForm.fileid!==''&&editForm.fileid!==undefined">
            <el-button :loading="importloading" slot="reference" icon="el-icon-finished">解析报价单</el-button>
          </el-popconfirm>
        </el-form-item>
        <el-row v-if="editForm.offerFileid!==null&&editForm.offerFileid!==''&&editForm.offerFileid!==undefined" v-loading="oldOfferLoading">
          <el-col :span="24">
            <el-form-item label="报价分解">
              <el-card shadow="never" class="tcf-offer-card">
                <el-collapse v-model="bjfjActiveNames">
                  <el-collapse-item title="品类报价" name="1">
                    <el-col :span="12">
                      <el-form-item label="墙板" prop="wall">
                        <el-input v-model="editForm.wall" oninput ="value=value.replace(/[^0-9.]/g,'')">
                          <template slot="append">元</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="柜体" prop="cabinet">
                        <el-input v-model="editForm.cabinet" oninput ="value=value.replace(/[^0-9.]/g,'')">
                          <template slot="append">元</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="门类" prop="door">
                        <el-input v-model="editForm.door" oninput ="value=value.replace(/[^0-9.]/g,'')">
                          <template slot="append">元</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="配件" prop="access">
                        <el-input v-model="editForm.access" oninput ="value=value.replace(/[^0-9.]/g,'')">
                          <template slot="append">元</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="铝材" prop="aluminum">
                        <el-input v-model="editForm.aluminum" oninput ="value=value.replace(/[^0-9.]/g,'')">
                          <template slot="append">元</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-collapse-item>
                  <el-collapse-item title="系列报价" name="3" v-show="downnum.indexOf('SZ')<0">
                    <el-col :span="12">
                      <el-form-item label="乔金斯" prop="jokins">
                        <el-input v-model="editForm.jokins" oninput ="value=value.replace(/[^0-9.]/g,'')">
                          <template slot="append">元</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="云庭御邑" prop="yt">
                        <el-input v-model="editForm.yt" oninput ="value=value.replace(/[^0-9.]/g,'')">
                          <template slot="append">元</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-collapse-item>
                  <el-collapse-item title="工艺报价" name="2">
                    <el-col :span="12">
                      <el-form-item label="混油" prop="oil">
                        <el-input v-model="editForm.oil" oninput ="value=value.replace(/[^0-9.]/g,'')">
                          <template slot="append">元</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="贴皮" prop="tiepi">
                        <el-input v-model="editForm.tiepi" oninput ="value=value.replace(/[^0-9.]/g,'')">
                          <template slot="append">元</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="免漆板" prop="paint">
                        <el-input v-model="editForm.paint" oninput ="value=value.replace(/[^0-9.]/g,'')">
                          <template slot="append">元</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-collapse-item>
                </el-collapse>
              </el-card>
            </el-form-item>
          </el-col>
          <el-col :span="24" style="padding: 10px 0 10px 90px;">
            <span style="color:#99a9bf;font-size:12px;"><i class="el-icon-info" style="margin-right:6px;"></i>报价提示：订单金额 = 墙板 + 柜体 + 门类 + 配件 + 铝材 + 加价 + 其他费用 + 更改单费用 - 优惠 - 更改单退款</span>
          </el-col>
          <el-col :span="24">
            <el-form-item label="订单金额">
              <span style="font-weight: 500;color:#409EFF;margin-left: 10px;font-size: 16px">{{editForm.amount}}</span>
              <span style="font-size: 12px">元</span>
              <s style="font-size: 13px;color:#999;margin-left: 10px" v-if="editForm.amount!==editForm.totalprice">{{editForm.totalprice}}</s>
              <el-tag type="danger" size="mini" style="margin-left: 10px" v-if="parseFloat(editForm.discount)>0">{{editForm.discount}} 折</el-tag>
              <span style="font-size: 12px;float: right">
                （ 大写：{{UpperAmount}} ）
              </span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="加价" prop="raise">
              <el-input v-model="editForm.raise" oninput="value=value.replace(/[-][^0-9.]/g,'')">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="优惠" prop="best">
              <el-input v-model="editForm.best">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="折扣" prop="discount">
              <el-input v-model="editForm.discount" oninput ="value=value.replace(/[^0-9.]/g,'')">
                <template slot="append">折</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="返点/折扣">
              <el-card shadow="never" class="tcf-offer-rebate-card">
                <el-collapse>
                  <el-collapse-item>
                    <template slot="title">
                      业绩/支票返点（合计：{{editForm.rebateAmount}}）
                    </template>
                    <el-table
                      ref="multipleRebateTable"
                      :data="editForm.bjRebateList"
                      :show-header="false"
                      style="width: 100%"
                      @selection-change="handleRebateSelectionChange">
                      <el-table-column
                        type="selection"
                        width="45">
                      </el-table-column>
                      <el-table-column
                        label="返点名称"
                        min-width="160"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-tag :disable-transitions="true" size="mini" v-if="scope.row.credit===0">冲抵{{scope.row.maximpact}}%</el-tag>
                          <el-tag :disable-transitions="true" size="mini" v-if="scope.row.credit===9">任意冲抵</el-tag>
                          <el-tag :disable-transitions="true" size="mini" type="warning">最低{{scope.row.mindiscount}}折</el-tag>
                          <span style="color:#000;margin-left: 2px;cursor: pointer" @click="viewRebateDateil(scope.row)">{{scope.row.name}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="余额"
                        width="100"
                        align="right"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                          <span style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin"></i> {{scope.row.balance}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="优惠金额"
                        width="160"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.discountAmount" :disabled="!scope.row.ischeck" placeholder="优惠金额" oninput ="value=value.replace(/[^0-9.]/g,'')">
                            <template slot="append">元</template>
                          </el-input>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-collapse-item>
                  <el-collapse-item>
                    <template slot="title">
                      报备金折扣（合计：{{editForm.reportAmount}}）
                    </template>
                    <el-table
                      :data="editForm.bjReportList"
                      ref="multipleReportTable"
                      :show-header="false"
                      style="width: 100%"
                      @selection-change="handleReportSelectionChange">
                      <el-table-column
                        type="selection"
                        width="45">
                      </el-table-column>
                      <el-table-column
                        label="报备金名称"
                        min-width="160"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-tag :disable-transitions="true" size="mini" type="warning">最低{{scope.row.mindiscount}}折</el-tag>
                          <span style="color:#000;margin-left: 2px;cursor: pointer" @click="viewReportDateil(scope.row)">{{scope.row.name}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="当前折扣"
                        width="160"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.currentDiscount" :disabled="!scope.row.ischeck" placeholder="当前折扣" oninput ="value=value.replace(/[^0-9.]/g,'')">
                            <template slot="append">折</template>
                          </el-input>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="优惠金额"
                        width="160"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.discountAmount" :disabled="!scope.row.ischeck" placeholder="优惠金额" oninput ="value=value.replace(/[^0-9.]/g,'')">
                            <template slot="append">元</template>
                          </el-input>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-collapse-item>
                  <el-collapse-item>
                    <template slot="title">
                      临时折扣（合计：{{editForm.tempAmount}}）
                    </template>
                    <el-table
                      :data="editForm.bjTempList"
                      ref="multipleTempTable"
                      :show-header="false"
                      style="width: 100%"
                      @selection-change="handleTempSelectionChange">
                      <el-table-column
                        type="selection"
                        width="45">
                      </el-table-column>
                      <el-table-column
                        label="折扣名称"
                        min-width="160"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-tag :disable-transitions="true" size="mini" type="warning">最低{{scope.row.mindiscount}}折</el-tag>
                          <span style="color:#000;margin-left: 2px;cursor: pointer" @click="viewTempDateil(scope.row)">{{scope.row.name}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="折扣/金额"
                        width="100"
                        align="right"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                          <span v-if="scope.row.credit===0" style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin"></i> {{scope.row.amount}}</span>
                          <span v-if="scope.row.credit===1" style="color:#409EFF;font-weight: 500;">{{scope.row.discount}}折</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="优惠金额"
                        width="160"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.discountAmount" :disabled="!scope.row.ischeck" placeholder="优惠金额" oninput ="value=value.replace(/[^0-9.]/g,'')">
                            <template slot="append">元</template>
                          </el-input>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-collapse-item>
                </el-collapse>
              </el-card>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="其他费用">
              <el-card shadow="never" style="font-size: 12px">
                <div style="margin-bottom: 10px">
                  费用总计：<span style="font-size:12px;font-weight: 500;">{{editForm.other}}</span>
                  <el-button icon="el-icon-plus" style="float: right" @click="addOther">添加其他费用</el-button>
                </div>
                <el-row v-for="(item, index) in editForm.offerOther" :key="item.key" >
                  <el-col :span="4" style="padding-right: 6px">
                    <el-form-item :prop="'offerOther.' + index +'.type'" :rules="offerOtherRules.type">
                      <el-select v-model="item.type" placeholder="类型">
                        <el-option label="其他" :value="0"></el-option>
                        <el-option label="木架" :value="1"></el-option>
                        <el-option label="调色" :value="2"></el-option>
                        <el-option label="水性漆" :value="3"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item :prop="'offerOther.' + index +'.name'" :rules="offerOtherRules.name">
                      <el-input v-model="item.name" placeholder="请输入费用说明" ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6" style="padding-left: 6px">
                    <el-form-item :prop="'offerOther.' + index +'.amount'" :rules="offerOtherRules.amount">
                      <el-input v-model="item.amount" placeholder="金额" oninput="value=value.replace(/[-][^0-9.]/g,'')">
                        <template slot="append">元</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2" style="text-align: right">
                    <el-button type="danger" @click="delOther(index)" icon="el-icon-delete" plain></el-button>
                  </el-col>
                </el-row>
              </el-card>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="editForm.changelst.length>0">
            <el-form-item label="更改单费用">
              <el-card shadow="never" style="font-size: 12px">
                <div style="margin-bottom: 10px">
                  费用总计：<span style="font-size:12px;font-weight: 500;">{{editForm.changes}}</span>
                  <span v-if="editForm.refund>0">，退款<span style="color:#F56C6C;font-size: 14px;margin-right: 6px;margin-left: 6px">{{ editForm.refund }}</span>元（报价提交后将退款金额计入优惠中）</span>
                </div>
                <el-table
                  :data="editForm.changelst"
                  size="mini"
                  :show-header="false"
                  style="width: 100%">
                  <el-table-column
                    prop="num"
                    label="更改单号"
                    width="200"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag :disable-transitions="true" size="mini" style="margin-right: 6px" v-if="scope.row.type===0" type="danger">设计变更</el-tag>
                      <el-tag :disable-transitions="true" size="mini" style="margin-right: 6px" v-if="scope.row.type===1" class="tcf-tag-4">材质变更</el-tag>
                      <el-tag :disable-transitions="true" size="mini" style="margin-right: 6px" v-if="scope.row.type===2" class="tcf-tag-6">暂停生产</el-tag>
                      <el-tag :disable-transitions="true" size="mini" style="margin-right: 6px" v-if="scope.row.type===3" class="tcf-tag-7">取消订单</el-tag>
                      <el-tag :disable-transitions="true" size="mini" style="margin-right: 6px" v-if="scope.row.type===4" class="tcf-tag-2">颜色变更</el-tag>
                      <el-tag :disable-transitions="true" size="mini" style="margin-right: 6px" v-if="scope.row.type===5" type="warning">通知单</el-tag>
                      <el-tag :disable-transitions="true" size="mini" style="margin-right: 6px" v-if="scope.row.type===6" class="tcf-tag-10">其他</el-tag>
                      {{scope.row.num}}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="content"
                    label="变更内容"
                    min-width="200"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    label="更改费用"
                    width="100"
                    fixed="right"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#f56c6c">{{scope.row.amount}}</span>元
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    width="100"
                    fixed="right"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-button type="text" @click="viewOrderChange(scope.row)" icon="el-icon-search" size="mini">详细</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-card>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="editForm.ordertype===4">
            <el-form-item label="设计承担" prop="designcom">
              <el-input v-model="editForm.designcom" oninput ="value=value.replace(/[^0-9.]/g,'')">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="editForm.ordertype===4">
            <el-form-item label="工厂承担" prop="factorycom">
              <el-input v-model="editForm.factorycom" oninput ="value=value.replace(/[^0-9.]/g,'')">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="editForm.ordertype===4">
            <el-form-item label="客户承担" prop="clientcom">
              <el-input v-model="editForm.clientcom" :disabled="true">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="报价备注" prop="content">
          <el-input type="textarea" v-model="editForm.content" maxlength="200" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="确认凭证" prop="imgids" v-if="editForm.offerFileid!==null&&editForm.offerFileid!==''&&editForm.offerFileid!==undefined">
          <span style="color:#99a9bf;font-size: 12px"><i class="el-icon-info"></i> 更改折扣与优惠必须上传领导确认凭证</span><span style="color:#F56C6C;font-size: 12px">（这里上传的图片经销商不可见）</span>
          <MultiImg v-model="editForm.imgids" :old="editimgList" :key="imgLoad" :size="'sm'"></MultiImg>
        </el-form-item>
        <el-form-item label="公开凭证" prop="pubimgids" v-if="editForm.offerFileid!==null&&editForm.offerFileid!==''&&editForm.offerFileid!==undefined">
          <span style="color:#F56C6C;font-size: 12px"><i class="el-icon-info"></i> 这里上传的图片所有人可见</span>
          <MultiImg v-model="editForm.pubimgids" :old="editpubimgList" :key="pubimgLoad" :size="'sm'"></MultiImg>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-popconfirm title="确认提交此报价吗？" :key="btnKey" placement="top" @onConfirm="subEdit('editForm')">
            <el-button type="primary" slot="reference" icon="el-icon-check" :loading="editloading">确认报价</el-button>
          </el-popconfirm>
          <el-button v-if="iseditOffer===false" type="danger" icon="el-icon-close" style="margin-left: 10px" :loading="editloading" @click="turn('editForm')">驳回</el-button>
          <el-button @click="editVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="订单拆单详情"
      :visible.sync="materialVisible"
      width="80%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :before-close="closeMaterial"
      :append-to-body="true">
      <div style="height: 490px;width: 100%" v-loading="materialloading">
      <pl-table
        height="490px"
        :datas="materialTableData"
        :data="materialTableData"
        border
        size="small"
        use-virtual
        :pagination-show="false"
        :row-height="45">
        <pl-table-column prop="xuhao" label="序号" width="80" show-overflow-tooltip fixed></pl-table-column>
        <pl-table-column prop="area" label="区域" width="120" show-overflow-tooltip></pl-table-column>
        <pl-table-column prop="type" label="分类" width="80" show-overflow-tooltip></pl-table-column>
        <pl-table-column prop="name" label="名称" width="160" show-overflow-tooltip></pl-table-column>
        <pl-table-column prop="material" label="基材" width="80" show-overflow-tooltip></pl-table-column>
        <pl-table-column prop="high" label="高/长" width="70" show-overflow-tooltip></pl-table-column>
        <pl-table-column prop="width" label="宽" width="70" show-overflow-tooltip></pl-table-column>
        <pl-table-column prop="lwidth" label="L宽" width="70" show-overflow-tooltip></pl-table-column>
        <pl-table-column prop="ply" label="厚" width="70" show-overflow-tooltip></pl-table-column>
        <pl-table-column prop="num" label="数量" width="70" show-overflow-tooltip></pl-table-column>
        <pl-table-column prop="val" label="数值" width="70" show-overflow-tooltip></pl-table-column>
        <pl-table-column prop="unit" label="单位" width="70" show-overflow-tooltip></pl-table-column>
        <pl-table-column prop="color" label="颜色" width="140" show-overflow-tooltip></pl-table-column>
        <pl-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip></pl-table-column>
      </pl-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="materialTableData=[],materialVisible=false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="订单改价记录"
      :visible.sync="changeRecordDialog"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <div v-loading="changeRecordLoading" style="height:300px;">
        <pl-table
          height="300px"
          :datas="changePriceData"
          :data="changePriceData"
          border
          style="width: 100%"
          :pagination-show="false"
          size="small"
          :row-height="45"
        >
          <pl-table-column
            prop="username"
            :resizable="false"
            label="改价人"
            align="center"
            width="100"
            show-overflow-tooltip>
          </pl-table-column>
          <pl-table-column
            prop="time"
            :resizable="false"
            align="center"
            label="改价时间"
            min-width="160"
            show-overflow-tooltip>
          </pl-table-column>
          <pl-table-column
            prop="oldamount"
            :resizable="false"
            align="center"
            label="原报价金额"
            width="100"
            show-overflow-tooltip>
          </pl-table-column>
          <pl-table-column
            prop="newamount"
            :resizable="false"
            align="center"
            label="改后报价金额"
            width="100"
            show-overflow-tooltip>
          </pl-table-column>
        </pl-table>
      </div>
    </el-dialog>
    <el-dialog
      title="业绩/支票返点详情"
      :visible.sync="viewRebateVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <table class="tcf-detail-table" v-loading="viewRebateLoading">
        <tr>
          <th>申请人</th>
          <td>{{ viewRebatedata.username }}</td>
          <th>申请时间</th>
          <td colspan="3">{{ viewRebatedata.time }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ viewRebatedata.delname }}</td>
          <th>返点名称</th>
          <td colspan="3" style="color:#000;">{{ viewRebatedata.name }}</td>
        </tr>
        <tr>
          <th>有效期</th>
          <td colspan="5">
            <span v-if="viewRebatedata.starttime==='0'"><i class="el-icon-date"></i> 无期限</span>
            <span v-if="viewRebatedata.starttime!=='0'"><i class="el-icon-date"></i> {{viewRebatedata.starttime}} ~ {{viewRebatedata.endtime}}</span>
          </td>
        </tr>
        <tr>
          <th>返点总额</th>
          <td style="font-weight: 500;"><i class="el-icon-coin"></i> {{ viewRebatedata.amount }}</td>
          <th>返点余额</th>
          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin"></i> {{ viewRebatedata.balance }}</td>
          <th>抵款方式</th>
          <td>
            <span v-if="viewRebatedata.credit===0">最高冲抵{{viewRebatedata.maximpact}}%</span>
            <span v-if="viewRebatedata.credit===1">享受{{viewRebatedata.maxdiscount}}折</span>
            <span v-if="viewRebatedata.credit===9">任意冲抵</span>
          </td>
        </tr>
        <tr>
          <th>适用订单</th>
          <td>
            <span v-if="viewRebatedata.ordertype===0">无限制</span>
            <span v-if="viewRebatedata.ordertype===1">正单</span>
            <span v-if="viewRebatedata.ordertype===2">补单</span>
          </td>
          <td colspan="4">
            订单金额满 {{viewRebatedata.orderMoney}} 元以上可享受，同比享受最低折扣不低于 {{viewRebatedata.mindiscount}} 折
          </td>
        </tr>
        <tr>
          <th>返点凭证</th>
          <td colspan="5">
            <el-image v-for="iurl in imgRebateSrcList"
                      style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
                      :src="iurl"
                      :preview-src-list="imgRebateSrcList">
            </el-image>
          </td>
        </tr>
        <tr>
          <th>备注说明</th>
          <td colspan="5">{{ viewRebatedata.remark }}</td>
        </tr>
        <tr  v-if="viewRebatedata.mark===2">
          <th>审核人</th>
          <td>{{ viewRebatedata.auditname }}</td>
          <th>审核时间</th>
          <td colspan="3">{{ viewRebatedata.audittime }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewRebateVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="报备金详情"
      :visible.sync="viewReportVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <table class="tcf-detail-table" v-loading="viewReportLoading">
        <tr>
          <th>申请人</th>
          <td>{{ viewReportdata.username }}</td>
          <th>申请时间</th>
          <td colspan="3">{{ viewReportdata.time }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ viewReportdata.delname }}</td>
          <th style="width: 100px">报备金名称</th>
          <td colspan="3" style="color:#000;">{{ viewReportdata.name }}</td>
        </tr>
        <tr>
          <th>报备要求</th>
          <td>
            {{viewReportdata.per}}/单
          </td>
          <td colspan="4">
            同比享受最低折扣不低于 {{viewReportdata.mindiscount}} 折
          </td>
        </tr>
        <tr>
          <th>终端地址</th>
          <td colspan="5">
            <table class="tcf-detail-table">
              <tr v-for="(d,index) in viewReportAddress">
                <td style="width: 50px;text-align: center">{{ index+1 }}</td>
                <td>{{ d.address }}</td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <th>有效期</th>
          <td colspan="5">
            <span><i class="el-icon-date"></i> {{viewReportdata.starttime}} ~ {{viewReportdata.endtime}}</span>
          </td>
        </tr>
        <tr>
          <th>对应折扣</th>
          <td colspan="5">
            <table class="tcf-detail-table">
              <tr v-for="(d,index) in viewReportDiscount">
                <td style="width: 50px;text-align: center">{{ index+1 }}</td>
                <td>{{ d.starttime }} 至 {{ d.endtime }}</td>
                <td style="width: 100px;text-align: center">{{ d.discount }}折</td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <th>打款账户</th>
          <td colspan="5">{{ viewReportAcccount.groupname }}（{{ viewReportAcccount.name }}，{{ viewReportAcccount.card }}）</td>
        </tr>
        <tr>
          <th>打款金额</th>
          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin"></i> {{ viewReportdata.amount }}</td>
          <th>打款日期</th>
          <td>{{ viewReportdata.receipttime }}</td>
          <th>打款性质</th>
          <td>{{ viewReportdata.nature }}</td>
        </tr>
        <tr>
          <th>报备凭证</th>
          <td colspan="5">
            <el-image v-for="iurl in imgReportSrcList"
                      style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
                      :src="iurl"
                      :preview-src-list="imgReportSrcList">
            </el-image>
          </td>
        </tr>
        <tr>
          <th>备注说明</th>
          <td colspan="5">{{ viewReportdata.remark }}</td>
        </tr>
        <tr  v-if="viewReportdata.mark===2">
          <th>审核人</th>
          <td>{{ viewReportdata.auditname }}</td>
          <th>审核时间</th>
          <td colspan="3">{{ viewReportdata.audittime }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewReportVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="临时折扣详情"
      :visible.sync="viewTempDiscountVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <table class="tcf-detail-table" v-loading="infoTempDiscountLoading">
        <tr>
          <th>申请人</th>
          <td>{{ viewTempDiscountData.username }}</td>
          <th>申请时间</th>
          <td colspan="3">{{ viewTempDiscountData.time }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ viewTempDiscountData.delname }}</td>
          <th>折扣名称</th>
          <td colspan="3" style="color:#000;">{{ viewTempDiscountData.name }}</td>
        </tr>
        <tr>
          <th>使用状态</th>
          <td>
            <el-tag :disable-transitions="true" size="mini" v-if="viewTempDiscountData.mark===2">未使用</el-tag>
            <el-tag :disable-transitions="true" size="mini" v-if="viewTempDiscountData.mark===9" type="success">已使用</el-tag>
          </td>
          <td colspan="4">
            同比享受最低折扣不低于 {{viewTempDiscountData.mindiscount}} 折
          </td>
        </tr>
        <tr>
          <th>有效期</th>
          <td colspan="5">
            <span v-if="viewTempDiscountData.starttime==='0'"><i class="el-icon-date"></i> 无期限</span>
            <span v-if="viewTempDiscountData.starttime!=='0'"><i class="el-icon-date"></i> {{viewTempDiscountData.starttime}} ~ {{viewTempDiscountData.endtime}}</span>
          </td>
        </tr>
        <tr>
          <th style="width: 90px">折扣/金额</th>
          <td style="color:#409EFF;font-weight: 500;">
            <span v-if="viewTempDiscountData.credit===0"><i class="el-icon-coin"></i> {{ viewTempDiscountData.amount }}</span>
            <span v-if="viewTempDiscountData.credit===1">{{ viewTempDiscountData.discount }}折</span>
          </td>
          <th>抵款方式</th>
          <td colspan="3">
            <span v-if="viewTempDiscountData.credit===0">金额冲抵</span>
            <span v-if="viewTempDiscountData.credit===1">享受折扣</span>
          </td>
        </tr>
        <tr>
          <th>折扣凭证</th>
          <td colspan="5">
            <el-image v-for="iurl in imgTempDiscountSrcList"
                      style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
                      :src="iurl"
                      :preview-src-list="imgTempDiscountSrcList">
            </el-image>
          </td>
        </tr>
        <tr>
          <th>备注说明</th>
          <td colspan="5">{{ viewTempDiscountData.remark }}</td>
        </tr>
        <tr>
          <th>审核人</th>
          <td>{{ viewTempDiscountData.auditname }}</td>
          <th>审核时间</th>
          <td colspan="3">{{ viewTempDiscountData.audittime }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewTempDiscountVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="viewOrderChangeTitle"
      :visible.sync="viewOrderChangeVisible"
      width="1120px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-row v-loading="viewOrderChangeLoading">
        <el-col :span="10">
          <table class="tcf-detail-table">
            <tr>
              <th>更改单号</th>
              <td>{{viewOrderChangeData.oc.num}}</td>
              <th>生产单号</th>
              <td>{{viewOrderChangeData.oc.produnum}}</td>
            </tr>
            <tr>
              <th>详细地址</th>
              <td colspan="3">{{viewOrderChangeData.oc.address}}</td>
            </tr>
            <tr>
              <th>变更类别</th>
              <td>
                <span v-if="viewOrderChangeData.oc.type===0">设计变更</span>
                <span v-if="viewOrderChangeData.oc.type===1">材质变更</span>
                <span v-if="viewOrderChangeData.oc.type===2">暂停生产</span>
                <span v-if="viewOrderChangeData.oc.type===3">取消订单</span>
                <span v-if="viewOrderChangeData.oc.type===4">颜色变更</span>
                <span v-if="viewOrderChangeData.oc.type===5">通知单</span>
                <span v-if="viewOrderChangeData.oc.type===6">其他</span>
              </td>
              <th>申请部门</th>
              <td>
                <span v-if="viewOrderChangeData.oc.dept===0">客户</span>
                <span v-if="viewOrderChangeData.oc.dept===1">拆单</span>
                <span v-if="viewOrderChangeData.oc.dept===2">方案</span>
                <span v-if="viewOrderChangeData.oc.dept===3">车间</span>
                <span v-if="viewOrderChangeData.oc.dept===4">采购</span>
                <span v-if="viewOrderChangeData.oc.dept===5">软件</span>
                <span v-if="viewOrderChangeData.oc.dept===6">其他</span>
                <span v-if="viewOrderChangeData.oc.dept===7">建模</span>
                <span v-if="viewOrderChangeData.oc.dept===8">研发</span>
              </td>
            </tr>
            <tr>
              <th>变更内容</th>
              <td colspan="3"><div class="pl">{{ viewOrderChangeData.oc.content }}</div></td>
            </tr>
            <tr>
              <th>拆单人员</th>
              <td>{{viewOrderChangeData.oc.splitname}}</td>
              <th>生产动态</th>
              <td style="font-weight: bold;color:#f56c6c">
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===0">PMC阶段</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===1">开料完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===2">组装完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===3">贴皮完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===4">白胚完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===5">做灰完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===6">底漆完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===7">粗磨完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===8">二次底漆完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===9">细磨完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===10">面漆完工</span>
                <span v-if="viewOrderChangeData.oc.mark>2&&viewOrderChangeData.oc.progress===11">包装完工</span>
              </td>
            </tr>
            <tr>
              <th>变更原因</th>
              <td colspan="3">{{viewOrderChangeData.oc.rson}}</td>
            </tr>
            <tr>
              <th colspan="2" style="text-align: center">变更前内容</th>
              <th colspan="2" style="text-align: center">变更后内容</th>
            </tr>
            <tr>
              <td colspan="2">{{viewOrderChangeData.oc.beforetxt}}</td>
              <td colspan="2">{{viewOrderChangeData.oc.aftertxt}}</td>
            </tr>
            <tr v-if="viewOrderChangeData.oc.offerid!==0&&viewOrderChangeData.oc.mark>4">
              <th>报价明细</th>
              <td colspan="3">{{viewOrderChangeData.oc.offerdetail}}</td>
            </tr>
            <tr v-if="viewOrderChangeData.oc.mark>4">
              <th v-if="viewOrderChangeData.oc.offerid!==0&&viewOrderChangeData.oc.mark>4">报价费用</th>
              <td v-if="viewOrderChangeData.oc.offerid!==0&&viewOrderChangeData.oc.mark>4" style="font-weight: bold;color:#409EFF">{{viewOrderChangeData.oc.mark>4?viewOrderChangeData.oc.amount:''}}</td>
              <th>交期延长</th>
              <td :colspan="viewOrderChangeData.oc.offerid!==0&&viewOrderChangeData.oc.mark>4?1:3">{{viewOrderChangeData.oc.mark>6?viewOrderChangeData.oc.day+'天':''}}</td>
            </tr>
          </table>
        </el-col>
        <el-col :span="5">
          <el-timeline>
            <el-timeline-item
              :type="viewOrderChangeData.oc.mark>0?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>0?viewOrderChangeData.oc.time:''">
              提交
              <div v-if="viewOrderChangeData.oc.mark>0" style="margin-top: 6px; font-size: 12px;">{{viewOrderChangeData.oc.initname}}<el-tag size="mini" :type="viewOrderChangeData.oc.inittype===0?'':'warning'" style="margin-left: 6px">{{ viewOrderChangeData.oc.initposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              :type="viewOrderChangeData.oc.mark>1?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>1?viewOrderChangeData.oc.sercontime:''">
              客服确认
              <div v-if="viewOrderChangeData.oc.mark>1" style="margin-top: 6px; font-size: 12px;">{{viewOrderChangeData.oc.servicename}}<el-tag size="mini" type="success" style="margin-left: 6px">{{ viewOrderChangeData.oc.serviceposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              :type="viewOrderChangeData.oc.mark>2?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>2?viewOrderChangeData.oc.pmctime:''">
              生产动态
              <div v-if="viewOrderChangeData.oc.mark>2" style="margin-top: 6px; font-size: 12px;">{{viewOrderChangeData.oc.pmcuname}}<el-tag size="mini" type="warning" style="margin-left: 6px">{{ viewOrderChangeData.oc.pmcuposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              :type="viewOrderChangeData.oc.mark>3?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>3?viewOrderChangeData.oc.assesstime:''">
              设计确认
              <div v-if="viewOrderChangeData.oc.mark>3" style="margin-top: 6px; font-size: 12px;">{{viewOrderChangeData.oc.assessname}}<el-tag size="mini" type="danger" style="margin-left: 6px">{{ viewOrderChangeData.oc.assessposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              v-if="viewOrderChangeData.oc.mark<=4||viewOrderChangeData.oc.offerid!==0"
              :type="viewOrderChangeData.oc.mark>4?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>4?viewOrderChangeData.oc.offertime:''">
              更改单报价
              <div v-if="viewOrderChangeData.oc.mark>4" style="margin-top: 6px; font-size: 12px;">{{viewOrderChangeData.oc.offername}}<el-tag size="mini" type="success" style="margin-left: 6px">{{ viewOrderChangeData.oc.offerposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              v-if="viewOrderChangeData.oc.mark<=5||viewOrderChangeData.oc.conid!==0"
              :type="viewOrderChangeData.oc.mark>5?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>5?viewOrderChangeData.oc.contime:''">
              客户确认
              <div v-if="viewOrderChangeData.oc.mark>5" style="margin-top: 6px; font-size: 12px;">{{viewOrderChangeData.oc.conname}}<el-tag size="mini" :type="viewOrderChangeData.oc.contype===0?'':'warning'" style="margin-left: 6px">{{ viewOrderChangeData.oc.conposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              :type="viewOrderChangeData.oc.mark>6?'primary':''"
              :timestamp="viewOrderChangeData.oc.mark>6?viewOrderChangeData.oc.pmccontime:''">
              PMC确认
              <div v-if="viewOrderChangeData.oc.mark>6" style="margin-top: 6px; font-size: 12px;">{{viewOrderChangeData.oc.pmcconname}}<el-tag size="mini" type="danger" style="margin-left: 6px">{{ viewOrderChangeData.oc.pmcconposname }}</el-tag></div>
            </el-timeline-item>
            <el-timeline-item
              :type="viewOrderChangeData.oc.mark===100?'primary':''">
              完成
            </el-timeline-item>
          </el-timeline>
        </el-col>
        <el-col :span="9" class="tcf-order-change-remark">
          <div class="title">
            <span>更改单备注</span>
          </div>
          <div v-if="viewOrderChangeData.ocrlst.length===0" class="order-dynamic-not">
            暂无更改单备注数据
          </div>
          <div class="content-list">
            <div v-for="d in viewOrderChangeData.ocrlst" class="order-dynamic-item">
              <div class="photo">
                <el-avatar shape="square" :size="50" :src="d.photo"/>
              </div>
              <div class="info">
                <div class="username"><span>{{ d.username }}</span><el-tag v-if="d.posname!==null&&d.posname!==''&&d.posname!==undefined" :type="d.color===0?'':d.color===1?'success':d.color===2?'warning':''" size="mini">{{ d.posname }}</el-tag></div>
                <div class="time"><i class="el-icon-time" /> {{ d.time }}</div>
                <div class="content">
                  <div v-if="d.ispub===1" style="color:#f56c6c;"><i class="el-icon-lock"></i> 仅组织员工可见，经销商无法查看</div>
                  <el-tag v-if="d.ctype===1" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">客服确认驳回</el-tag>
                  <el-tag v-if="d.ctype===2" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">生产动态驳回</el-tag>
                  <el-tag v-if="d.ctype===3" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">设计确认驳回</el-tag>
                  <el-tag v-if="d.ctype===4" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">报价驳回</el-tag>
                  <el-tag v-if="d.ctype===5" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">客户确认驳回</el-tag>
                  <el-tag v-if="d.ctype===6" :disable-transitions="true" effect="dark" style="margin-right: 6px" size="mini" type="danger">PMC确认驳回</el-tag>
                  {{ d.content }}
                </div>
                <div class="files">
                  <div v-for="f in d.filelst" class="file-item" @click="downFile(f.fileid,0)">
                    <i class="el-icon-document" />
                    <div class="file-name">{{ f.file_name }}.{{ f.file_type }}</div>
                  </div>
                </div>
                <div class="imgs">
                  <el-image
                    v-for="img in d.imglst"
                    fit="cover"
                    class="dynamic-img"
                    :src="img"
                    :preview-src-list="d.imglst"
                  />
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import {
  getErpDealerAccountTempDetail,
  getOrderList,
  getErpOrderMaterialDetail,
  ErpOrderImportOffer,
  digitUppercase,
  offerOrder,
  getOrderQuoteDetail,
  getChangeOfferRecord,
  getRebateAndReportByOrderid,
  getDealerAccountRebateById,
  getDealerAccountReportById,
  getQuote,
  getOrderChangeDetail, exportOrderWaitOfferExcel
} from '@/api/erp'
import MultiImg from '@/components/upload/MultiImg'
import SingleFile from '@/components/upload/SingleFile'
import { getFileInfo } from '@/api/pub'
import qs from 'qs'
import { getBrandList } from '@/api/work'

export default {
  name: 'dbj',
  computed: {
    user: getUser
  },
  components: {
    MultiImg,
    SingleFile
  },
  data() {
    return {
      mark: 8,
      loading: false,
      tableData: [],
      quoteData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      fileLoad: '',
      importKey: '',
      btnKey: '',
      oldFile: [],
      istempFile: false,
      editVisible: false,
      editloading: false,
      materialVisible: false,
      materialloading: false,
      importloading: false,
      materialTableData: [],
      UpperAmount: '零元整',
      editForm: {
        ordertype: 0,
        splitname: '',
        splittime: '',
        splitfile: '',
        splitfileid: '',
        ordername: '',
        qid: [],
        fileid: '',
        offerFileid: '',
        bid: 1,
        orderid: '',
        content: '',
        imgids: [],
        pubimgids: [],
        totalprice: 0.0,
        wall: 0.0,
        cabinet: 0.0,
        access: 0.0,
        door: 0.0,
        raise: 0.0,
        discount: 0.0,
        best: 0.0,
        designcom: 0.0,
        factorycom: 0.0,
        clientcom: 0.0,
        other: 0.0,
        amount: 0.0,
        offerOther: [],
        aluminum: 0.0,
        oil: 0.0,
        tiepi: 0.0,
        paint: 0.0,
        jokins: null,
        yt: null,
        rebateAmount: 0.0,
        rebateSelection: [],
        bjRebateList: [],
        bjReportList: [],
        bjTempList: [],
        tempAmount: 0.0,
        reportAmount: 0.0,
        reportSelection: [],
        tempSelection: [],
        changes: 0.0,
        refund: 0.0,
        changelst: []
      },
      editRules: {
        qid: [{ required: true, message: '请选择报价书编码', trigger: 'change' }],
        ordername: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        content: [{ required: false, message: '请在这里填写驳回原因', trigger: 'blur' }],
        fileid: [{ required: true, message: '请上传报价单', trigger: 'change' }],
        offerFileid: [{ required: true, message: '请解析报价单', trigger: 'change' }],
        wall: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        cabinet: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        access: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        door: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        designcom: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        factorycom: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        clientcom: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        aluminum: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        paint: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        tiepi: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        oil: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        jokins: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        yt: [{ required: true, message: '请输入金额', trigger: 'blur' }]
      },
      offerOtherRules: {
        type: [{ required: true, message: '请选择费用类型', trigger: 'change' }],
        name: [{ required: true, message: '请输入费用说明', trigger: 'blur' }],
        amount: [{ required: true, message: '请输入费用金额', trigger: 'blur' }]
      },
      searchForm: {
        search: '',
        type: '',
        brandId: ''
      },
      brandList: [],
      downnum: '',
      oldOfferLoading: false,
      iseditOffer: false,
      imgLoad: '',
      pubimgLoad: '',
      editimgList: [],
      editpubimgList: [],
      changeRecordDialog: false,
      changeRecordLoading: false,
      changePriceData: [],
      bjfjActiveNames: ['1', '3'],
      viewRebateVisible: false,
      viewRebateLoading: false,
      viewRebatedata: [],
      imgRebateSrcList: [],
      viewReportVisible: false,
      viewReportLoading: false,
      viewReportdata: [],
      imgReportSrcList: [],
      viewReportAddress: [],
      viewReportDiscount: [],
      viewReportAcccount: [],
      imgTempDiscountSrcList: [],
      viewTempDiscountData: [],
      viewTempDiscountVisible: false,
      infoTempDiscountLoading: false,
      viewOrderChangeTitle: '',
      viewOrderChangeVisible: false,
      viewOrderChangeLoading: false,
      viewOrderChangeData: {
        oc: [],
        ocrlst: []
      },
      exportLoading: false
    }
  },
  created() {
    this.getData()
    this.getQuoteList()
    this.getBrandList()
  },
  watch: {
    'editForm.fileid': function(newVal) {
      if (!this.istempFile) {
        if (newVal === null || newVal === '' || newVal === undefined) {
          if (this.editForm.offerFileid !== null && this.editForm.offerFileid !== '' && this.editForm.offerFileid !== undefined) {
            this.editForm.offerFileid = ''
          }
        }
      } else {
        this.istempFile = false
      }
    },
    'editForm.wall': function(newVal) {
      this.countAmount()
    },
    'editForm.cabinet': function(newVal) {
      this.countAmount()
    },
    'editForm.access': function(newVal) {
      this.countAmount()
    },
    'editForm.door': function(newVal) {
      this.countAmount()
    },
    'editForm.aluminum': function(newVal) {
      this.countAmount()
    },
    'editForm.raise': function(newVal) {
      this.countAmount()
    },
    'editForm.best': function(newVal) {
      this.countAmount()
    },
    // 'editForm.discount': function(newVal) {
    //   this.countAmount()
    // },
    'editForm.other': function(newVal) {
      this.countAmount()
    },
    'editForm.changes': function(newVal) {
      this.countAmount()
    },
    'editForm.totalprice': function(newVal) {
      this.bearAmount()
    },
    'editForm.amount': function(newVal) {
      this.bearAmount()
    },
    'editForm.designcom': function(newVal) {
      this.bearAmount()
    },
    'editForm.factorycom': function(newVal) {
      this.bearAmount()
    },
    'editForm.clientcom': function(newVal) {
      this.bearAmount()
    },
    'editForm.offerOther': {
      handler(newValue, oldValue) {
        this.otherAmount()
      },
      deep: true
    },
    'editForm.bjRebateList': {
      handler(newValue, oldValue) {
        this.rebateAmount()
      },
      deep: true
    },
    'editForm.bjReportList': {
      handler(newValue, oldValue) {
        this.reportAmount()
      },
      deep: true
    },
    'editForm.bjTempList': {
      handler(newValue, oldValue) {
        this.tempAmount()
      },
      deep: true
    }
  },
  methods: {
    viewOrderChange(row) {
      if (!this.viewOrderChangeVisible) {
        this.viewOrderChangeTitle = `更改单 ${row.num} 详情`
        this.viewOrderChangeVisible = true
      }
      this.viewOrderChangeLoading = true
      getOrderChangeDetail({ ocid: row.ocid, role: 1 }).then(response => {
        this.viewOrderChangeLoading = false
        this.viewOrderChangeData = response.data
      }).catch(() => {
        this.viewOrderChangeLoading = false
      })
    },
    downFile(fileid, n) {
      getFileInfo({ fileid: fileid, productNum: '' }).then(response => {
        /* this.$message({
          message: '已下载 ' + response.data.dName + '.' + response.data.dType,
          type: 'success'
        })*/
        const a = document.createElement('a')
        // a.download = this.orderInfo.ordernum + '_' + response.data.dName + '.' + response.data.dType
        a.href = response.data.copyPath
        a.target = '_blank'
        a.click()
        const download = `${response.data.dName}.${response.data.dType}`
        const h = this.$createElement
        this.$msgbox({
          title: '下载提示',
          message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
            h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
            h('a',
              { attrs: {
                  href: response.data.copyPath,
                  target: '_blank',
                  download: download,
                  style: 'color: #409EFF;text-decoration:underline;'
                }}, `点击这里`),
            h('span', null, `重新下载。`)
          ]),
          showCancelButton: false,
          confirmButtonText: '关闭',
          beforeClose: (action, instance, done) => {
            done()
          }
        }).then(action => {
        })
      }).catch(() => {})
    },
    getQuoteList() {
      getQuote({ page: 1, limit: 99999 }).then(response => {
        this.quoteData = response.data
      })
    },
    getBrandList() {
      getBrandList().then(response => {
        this.brandList = response.data
      })
    },
    changeMark(n) {
      if (this.mark === n) {
        return false
      } else {
        this.mark = n
        this.currentPage = 1
        this.getData()
      }
    },
    Search() {
      this.currentPage = 1
      this.searchForm.search = this.searchForm.search.trim()
      this.getData()
    },
    getData() {
      this.loading = true
      let omark = '8'
      if (this.mark === 9) {
        omark = '9,10,11,12,13,100'
      }
      const data = {
        content: this.searchForm.search, // 搜索框内容
        page: this.currentPage, // 第几页
        limit: this.pageSize, // 显示几条数据
        userid: this.user.dUserid, // 登录用户的id
        mark: omark, // 订单状态
        groupid: this.user.dGroupid,
        role: this.user.role,
        type: this.searchForm.type,
        brandId: this.searchForm.brandId
      }
      getOrderList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    exportExcel() {
      if (!this.exportLoading) {
        this.exportLoading = true
        let omark = '8'
        if (this.mark === 9) {
          omark = '9,10,11,12,13,100'
        }
        const data = {
          content: this.searchForm.search,
          userid: this.user.dUserid,
          mark: omark,
          groupid: this.user.dGroupid,
          role: this.user.role,
          type: this.searchForm.type,
          brandId: this.searchForm.brandId
        }
        exportOrderWaitOfferExcel(data).then(response => {
          this.exportLoading = false
          const _this = this
          let xhr = new XMLHttpRequest()
          xhr.open('GET', response.data.dPath, true)
          xhr.responseType = 'blob'
          xhr.onload = function() {
            if (this.status === 200) {
              let blob = this.response
              let a = document.createElement('a')
              a.download = response.data.dName + '.' + response.data.dType
              a.href = window.URL.createObjectURL(blob)
              a.target = '_blank'
              a.click()
              const h = _this.$createElement
              _this.$msgbox({
                title: '下载提示',
                message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                  h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                  h('a',
                    { attrs: {
                      href: window.URL.createObjectURL(blob),
                      target: '_blank',
                      download: `${response.data.dName}.${response.data.dType}`,
                      style: 'color: #409EFF;text-decoration:underline;'
                    }}, `点击这里`),
                  h('span', null, `重新下载。`)
                ]),
                showCancelButton: false,
                confirmButtonText: '关闭',
                beforeClose: (action, instance, done) => {
                  done()
                }
              }).then(action => {
              })
            }
          }
          xhr.send()
        }).catch(() => {
          this.exportLoading = false
        })
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      this.$router.push({ path: '/work/order/' + row.order_id })
    },
    closeMaterial() {
      this.materialTableData = []
      this.materialVisible = false
    },
    // 这个是取消下载报价书的功能！！！！
    // downQuote() {
    //   if (this.editForm.qid === null || this.editForm.qid === '' || this.editForm.qid === undefined || this.editForm.qid === 0 || this.editForm.qid === '0') {
    //     this.$message({
    //       message: '请选择报价书',
    //       type: 'error'
    //     })
    //     return
    //   }
    //   let row = null
    //   for (const q of this.quoteData) {
    //     if (q.qid === this.editForm.qid) {
    //       row = q
    //       break
    //     }
    //   }
    //   if (row !== null) {
    //     getFileInfo({ fileid: row.fileid }).then(response => {
    //       const a = document.createElement('a')
    //       a.href = response.data.copyPath
    //       a.click()
    //       const h = this.$createElement
    //       this.$msgbox({
    //         title: '下载提示',
    //         message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
    //           h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
    //           h('a',
    //             { attrs: {
    //                 href: response.data.copyPath,
    //                 target: '_blank',
    //                 download: `${response.data.dName}.${response.data.dType}`,
    //                 style: 'color: #409EFF;text-decoration:underline;'
    //               }}, `点击这里`),
    //           h('span', null, `重新下载。`)
    //         ]),
    //         showCancelButton: false,
    //         confirmButtonText: '关闭',
    //         beforeClose: (action, instance, done) => {
    //           done()
    //         }
    //       }).then(action => {
    //       })
    //     }).catch(() => {})
    //   }
    // },

    downMaterial() {
      getFileInfo({ fileid: this.editForm.splitfileid, productNum: this.downnum }).then(response => {
        /* this.$message({
          message: '生产料单已下载',
          type: 'success'
        })*/
        const a = document.createElement('a')
        // a.download = response.data.dName + '.' + response.data.dType
        a.href = response.data.copyPath
        a.target = '_blank'
        a.click()
        const h = this.$createElement
        this.$msgbox({
          title: '下载提示',
          message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
            h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
            h('a',
              { attrs: {
                href: response.data.copyPath,
                target: '_blank',
                download: `${response.data.dName}.${response.data.dType}`,
                style: 'color: #409EFF;text-decoration:underline;'
              }}, `点击这里`),
            h('span', null, `重新下载。`)
          ]),
          showCancelButton: false,
          confirmButtonText: '关闭',
          beforeClose: (action, instance, done) => {
            done()
          }
        }).then(action => {
        })
      }).catch(() => {})
    },
    getMaterialDetail() {
      this.materialTableData = []
      this.materialVisible = true
      this.materialloading = true
      getErpOrderMaterialDetail({ orderid: this.editForm.orderid }).then(response => {
        this.materialloading = false
        this.materialTableData = response.data
      }).catch(() => {
        this.materialloading = false
      })
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        let tempindex = 0
        let rowspan = 1
        let temp = null
        for (let i = 0; i <= this.materialTableData.length; i++) {
          if (i === 0) {
            tempindex = i
            rowspan = 1
            temp = this.materialTableData[i].area
          } else {
            if (i === this.materialTableData.length) {
              if (rowIndex === tempindex) {
                return {
                  rowspan: rowspan,
                  colspan: 1
                }
              }
            } else {
              if (temp === this.materialTableData[i].area) {
                rowspan++
                if (rowIndex === i) {
                  return {
                    rowspan: 0,
                    colspan: 0
                  }
                }
              } else {
                if (rowIndex === tempindex) {
                  return {
                    rowspan: rowspan,
                    colspan: 1
                  }
                } else {
                  tempindex = i
                  rowspan = 1
                  temp = this.materialTableData[i].area
                }
              }
            }
          }
        }
      }
    },
    offer(row) {
      this.iseditOffer = false
      this.editRules.fileid[0].required = true
      this.editRules.offerFileid[0].required = true
      this.editRules.qid[0].required = true
      this.editRules.content[0].required = false
      this.editForm.orderid = row.order_id
      this.editForm.bid = row.brand_id
      this.editForm.ordertype = row.mark
      this.editForm.ordername = row.order_num + ' / ' + row.product_num + ' / ' + row.address
      this.downnum = row.product_num
      this.editForm.content = ''
      this.editForm.files = []
      this.editForm.imgids = []
      this.editForm.pubimgids = []
      this.editForm.splitname = row.splitname
      this.editForm.splittime = row.split_time
      this.editForm.splitfile = row.split_filename
      this.editForm.splitfileid = row.split_fileid
      this.istempFile = true
      this.editForm.fileid = ''
      this.editForm.offerFileid = ''
      if (row.offer_fileid !== null && row.offer_fileid !== '' && row.offer_fileid !== undefined) {
        this.oldFile = [{ name: row.offer_filename, id: row.offer_fileid }]
      } else {
        this.oldFile = []
      }
      this.btnKey = new Date().getTime()
      this.importKey = new Date().getTime() + 4
      this.fileLoad = new Date().getTime() + 3
      this.editimgList = []
      this.editpubimgList = []
      this.imgLoad = new Date().getTime() + 2
      this.pubimgLoad = new Date().getTime() + 1
      this.editForm.qid = []
      this.editForm.totalprice = 0.0
      this.editForm.wall = 0.0
      this.editForm.cabinet = 0.0
      this.editForm.access = 0.0
      this.editForm.door = 0.0
      this.editForm.raise = 0.0
      this.editForm.discount = 0.0
      this.editForm.best = 0.0
      this.editForm.designcom = 0.0
      this.editForm.factorycom = 0.0
      this.editForm.clientcom = 0.0
      this.editForm.other = 0.0
      this.editForm.amount = 0.0
      this.editForm.changes = 0.0
      this.editForm.changelst = []
      this.editForm.offerOther = []
      this.editForm.aluminum = 0.0
      this.editForm.oil = 0.0
      this.editForm.tiepi = 0.0
      this.editForm.paint = 0.0
      if (row.product_num.indexOf('SZ') >= 0) {
        this.editForm.jokins = 0
        this.editForm.yt = 0
      } else {
        this.editForm.jokins = null
        this.editForm.yt = null
      }
      this.bjfjActiveNames = ['1', '3']
      // 业绩支票返点/报备金折扣
      this.editForm.rebateAmount = 0.0
      this.editForm.rebateSelection = []
      this.editForm.bjRebateList = []
      this.editForm.bjReportList = []
      this.editForm.bjTempList = []
      this.editForm.reportAmount = 0.0
      this.editForm.reportSelection = []
      getRebateAndReportByOrderid({ orderid: this.editForm.orderid }).then(response => {
        this.editForm.bjRebateList = response.data.rebatelst
        this.editForm.bjReportList = response.data.repostlst
        this.editForm.bjTempList = response.data.templst
      }).catch(() => {
        this.editForm.bjRebateList = []
        this.editForm.bjReportList = []
        this.editForm.bjTempList = []
      })
      this.editVisible = true
    },
    viewRebateDateil(row) {
      this.imgRebateSrcList = []
      this.viewRebateVisible = true
      this.viewRebateLoading = true
      getDealerAccountRebateById({ darid: row.darid }).then(response => {
        this.viewRebateLoading = false
        this.viewRebatedata = response.data.dar
        let imgs = []
        for (let c of response.data.imgs) {
          imgs.push(c.img_url)
        }
        this.imgRebateSrcList = imgs
      }).catch(() => {
        this.viewRebateLoading = false
      })
    },
    viewReportDateil(row) {
      this.imgReportSrcList = []
      this.viewReportVisible = true
      this.viewReportLoading = true
      getDealerAccountReportById({ darid: row.darid }).then(response => {
        this.viewReportLoading = false
        this.viewReportdata = response.data.dar
        this.viewReportAddress = response.data.daralst
        this.viewReportDiscount = response.data.dardlst
        this.viewReportAcccount = response.data.acccount
        let imgs = []
        for (let c of response.data.imgs) {
          imgs.push(c.img_url)
        }
        this.imgReportSrcList = imgs
      }).catch(() => {
        this.viewReportLoading = false
      })
    },
    viewTempDateil(row) {
      this.viewTempDiscountVisible = true
      this.infoTempDiscountLoading = true
      this.imgTempDiscountSrcList = []
      getErpDealerAccountTempDetail({ datid: row.datid }).then(response => {
        this.infoTempDiscountLoading = false
        this.viewTempDiscountData = response.data
        let imgs = []
        for (let c of response.data.imglst) {
          imgs.push(c.imgurl)
        }
        this.imgTempDiscountSrcList = imgs
      }).catch(() => {
        this.infoTempDiscountLoading = false
      })
    },
    handleRebateSelectionChange(val) {
      this.editForm.rebateSelection = val
      for (let rb of this.editForm.bjRebateList) {
        let ischeck = false
        for (const s of this.editForm.rebateSelection) {
          if (s.darid === rb.darid) {
            ischeck = true
            if (!this.iseditOffer) {
              if (this.editForm.discount <= 0.0 || this.editForm.discount === null || this.editForm.discount === '' || this.editForm.discount === undefined) {
                this.editForm.discount = s.mindiscount
              } else {
                if (s.mindiscount < parseFloat(this.editForm.discount)) {
                  this.editForm.discount = s.mindiscount
                }
              }
            }
            break
          }
        }
        rb.ischeck = ischeck
      }
      if (!this.iseditOffer) {
        if (this.editForm.tempSelection.length <= 0 && this.editForm.rebateSelection.length <= 0 && this.editForm.reportSelection.length <= 0) {
          this.editForm.discount = 0
        }
      }
    },
    handleReportSelectionChange(val) {
      this.editForm.reportSelection = val
      for (let rb of this.editForm.bjReportList) {
        let ischeck = false
        for (const s of this.editForm.reportSelection) {
          if (s.darid === rb.darid) {
            ischeck = true
            if (!this.iseditOffer) {
              if (this.editForm.discount <= 0.0 || this.editForm.discount === null || this.editForm.discount === '' || this.editForm.discount === undefined) {
                this.editForm.discount = s.currentDiscount
              } else {
                if (parseFloat(s.currentDiscount) < parseFloat(this.editForm.discount)) {
                  this.editForm.discount = s.currentDiscount
                }
              }
            }
            break
          }
        }
        rb.ischeck = ischeck
      }
      if (!this.iseditOffer) {
        if (this.editForm.tempSelection.length <= 0 && this.editForm.reportSelection.length <= 0 && this.editForm.rebateSelection.length <= 0) {
          this.editForm.discount = 0
        }
      }
    },
    handleTempSelectionChange(val) {
      this.editForm.tempSelection = val
      for (let rb of this.editForm.bjTempList) {
        let ischeck = false
        for (const s of this.editForm.tempSelection) {
          if (s.datid === rb.datid) {
            ischeck = true
            if (!this.iseditOffer) {
              let _tempdiscount = s.discount
              if (s.credit === 0) {
                _tempdiscount = s.mindiscount
              }
              if (this.editForm.discount <= 0.0 || this.editForm.discount === null || this.editForm.discount === '' || this.editForm.discount === undefined) {
                this.editForm.discount = _tempdiscount
              } else {
                if (parseFloat(_tempdiscount) < parseFloat(this.editForm.discount)) {
                  this.editForm.discount = _tempdiscount
                }
              }
            }
            break
          }
        }
        rb.ischeck = ischeck
      }
      if (!this.iseditOffer) {
        if (this.editForm.tempSelection.length <= 0 && this.editForm.rebateSelection.length <= 0 && this.editForm.reportSelection.length <= 0) {
          this.editForm.discount = 0
        }
      }
    },
    rebateAmount() {
      if (this.editForm.rebateSelection.length > 0) {
        let amount = 0.0
        for (const sel of this.editForm.rebateSelection) {
          for (const rb of this.editForm.bjRebateList) {
            if (rb.darid === sel.darid) {
              if (rb.discountAmount !== null && rb.discountAmount !== '' && rb.discountAmount !== undefined) {
                amount = amount + parseFloat(rb.discountAmount)
              }
              if (parseFloat(rb.discountAmount) > parseFloat(rb.balance)) {
                this.$message.error(rb.name + '账户余额不足')
              }
              break
            }
          }
        }
        this.editForm.rebateAmount = amount.toFixed(2)
      } else {
        this.editForm.rebateAmount = 0.0
      }
      const bestAmount = parseFloat(this.editForm.rebateAmount) + parseFloat(this.editForm.reportAmount) + parseFloat(this.editForm.tempAmount)
      this.editForm.best = bestAmount.toFixed(2)
    },
    reportAmount() {
      if (this.editForm.reportSelection.length > 0) {
        let amount = 0.0
        for (const sel of this.editForm.reportSelection) {
          for (const rb of this.editForm.bjReportList) {
            if (rb.darid === sel.darid) {
              if (rb.discountAmount !== null && rb.discountAmount !== '' && rb.discountAmount !== undefined) {
                amount = amount + parseFloat(rb.discountAmount)
              }
              break
            }
          }
        }
        this.editForm.reportAmount = amount.toFixed(2)
      } else {
        this.editForm.reportAmount = 0.0
      }
      const bestAmount = parseFloat(this.editForm.rebateAmount) + parseFloat(this.editForm.reportAmount) + parseFloat(this.editForm.tempAmount)
      this.editForm.best = bestAmount.toFixed(2)
    },
    tempAmount() {
      if (this.editForm.tempSelection.length > 0) {
        let amount = 0.0
        for (const sel of this.editForm.tempSelection) {
          for (const rb of this.editForm.bjTempList) {
            if (rb.datid === sel.datid) {
              if (rb.discountAmount !== null && rb.discountAmount !== '' && rb.discountAmount !== undefined) {
                amount = amount + parseFloat(rb.discountAmount)
              }
              break
            }
          }
        }
        this.editForm.tempAmount = amount.toFixed(2)
      } else {
        this.editForm.tempAmount = 0.0
      }
      const bestAmount = parseFloat(this.editForm.rebateAmount) + parseFloat(this.editForm.reportAmount) + parseFloat(this.editForm.tempAmount)
      this.editForm.best = bestAmount.toFixed(2)
    },
    editOffer(row) {
      this.iseditOffer = true
      this.editRules.fileid[0].required = true
      this.editRules.offerFileid[0].required = true
      this.editRules.qid[0].required = true
      this.editRules.content[0].required = false
      this.editForm.orderid = row.order_id
      this.editForm.bid = row.brand_id
      this.editForm.ordertype = row.mark
      this.editForm.ordername = row.order_num + ' / ' + row.product_num + ' / ' + row.address
      this.downnum = row.product_num
      this.editForm.files = []
      this.editForm.imgids = []
      this.editForm.pubimgids = []
      this.editForm.splitname = row.splitname
      this.editForm.splittime = row.split_time
      this.editForm.splitfile = row.split_filename
      this.editForm.splitfileid = row.split_fileid
      this.istempFile = true
      this.editForm.fileid = ''
      if (row.offer_fileid !== null && row.offer_fileid !== '' && row.offer_fileid !== undefined) {
        this.oldFile = [{ name: row.offer_filename, id: row.offer_fileid }]
        this.editForm.offerFileid = row.offer_fileid
      } else {
        this.oldFile = []
        this.editForm.offerFileid = ''
      }
      this.btnKey = new Date().getTime()
      this.importKey = new Date().getTime()
      this.fileLoad = new Date().getTime()
      this.oldOfferLoading = true
      getOrderQuoteDetail({ orderid: row.order_id }).then(response => {
        if (response.data.qid == null) {
          this.editForm.qid = null
        } else {
          this.editForm.qid = response.data.qid
        }
        this.editForm.totalprice = response.data.totalprice
        this.editForm.wall = response.data.wall
        this.editForm.cabinet = response.data.cabinet
        this.editForm.access = response.data.access
        this.editForm.door = response.data.door
        this.editForm.amount = response.data.amount
        this.editForm.aluminum = response.data.aluminum
        this.editForm.oil = response.data.oil
        this.editForm.tiepi = response.data.tiepi
        this.editForm.paint = response.data.paint
        this.editForm.raise = response.data.raise
        this.editForm.discount = response.data.discount
        if (response.data.refund > 0) {
          let _best = response.data.best - response.data.refund
          if (_best>0) {
            this.editForm.best = _best.toFixed(2)
          } else {
            this.editForm.best = 0.00
          }
        } else {
          this.editForm.best = response.data.best
        }
        this.editForm.designcom = response.data.designcom
        this.editForm.factorycom = response.data.factorycom
        this.editForm.clientcom = response.data.clientcom
        this.editForm.other = response.data.other
        this.editForm.content = response.data.remark
        this.editForm.jokins = response.data.jokins
        this.editForm.yt = response.data.yt
        this.editForm.changelst = response.data.changelst
        this.editForm.refund = response.data.refund
        let _changes = 0.0
        for (const c of response.data.changelst) {
          _changes = _changes + parseFloat(c.factorycom) + parseFloat(c.clientcom) + parseFloat(c.designcom)
        }
        this.editForm.changes = _changes.toFixed(2)
        let _editimgList = []
        let _editpubimgList = []
        for (const i of response.data.imgmap) {
          if (i.ispub === 0) {
            _editimgList.push(i)
          } else {
            _editpubimgList.push(i)
          }
        }
        this.editimgList = _editimgList
        this.editpubimgList = _editpubimgList
        this.imgLoad = new Date().getTime()
        this.pubimgLoad = new Date().getTime() + 1
        this.editForm.offerOther = response.data.otherlst
        // 业绩支票返点/报备金折扣/临时折扣
        this.editForm.rebateAmount = 0.0
        this.editForm.rebateSelection = []
        this.editForm.bjRebateList = []
        this.editForm.bjReportList = []
        this.editForm.bjTempList = []
        this.editForm.reportAmount = 0.0
        this.editForm.reportSelection = []
        const dralst = response.data.dralst
        if (dralst.length > 0) {
          let rebateids = []
          let reportids = []
          let tempids = []
          for (const d of dralst) {
            if (d.type === 0) {
              rebateids.push(d.dataid)
            } else if (d.type === 2) {
              reportids.push(d.dataid)
            } else if (d.type === 3) {
              tempids.push(d.dataid)
            }
          }
          const data = {
            orderid: this.editForm.orderid,
            rebateids: rebateids.join(','),
            reportids: reportids.join(','),
            tempids: tempids.join(',')
          }
          getRebateAndReportByOrderid(data).then(response => {
            this.editForm.bjRebateList = response.data.rebatelst
            this.editForm.bjReportList = response.data.repostlst
            this.editForm.bjTempList = response.data.templst
            const _this = this
            setTimeout(function() {
              for (const rb of _this.editForm.bjRebateList) {
                if (rb.isold) {
                  _this.$refs.multipleRebateTable.toggleRowSelection(rb)
                }
              }
              for (const rb of _this.editForm.bjReportList) {
                if (rb.isold) {
                  _this.$refs.multipleReportTable.toggleRowSelection(rb)
                }
              }
              for (const rb of _this.editForm.bjTempList) {
                if (rb.isold) {
                  _this.$refs.multipleTempTable.toggleRowSelection(rb)
                }
              }
            }, 100)
          }).catch(() => {
            this.editForm.bjRebateList = []
            this.editForm.bjReportList = []
            this.editForm.bjTempList = []
          })
        } else {
          this.editForm.rebateAmount = 0.0
          this.editForm.rebateSelection = []
          this.editForm.bjRebateList = []
          this.editForm.bjReportList = []
          this.editForm.bjTempList = []
          this.editForm.reportAmount = 0.0
          this.editForm.reportSelection = []
          getRebateAndReportByOrderid({ orderid: this.editForm.orderid }).then(response => {
            this.editForm.bjRebateList = response.data.rebatelst
            this.editForm.bjReportList = response.data.repostlst
            this.editForm.bjTempList = response.data.templst
          }).catch(() => {
            this.editForm.bjRebateList = []
            this.editForm.bjReportList = []
            this.editForm.bjTempList = []
          })
        }
        this.oldOfferLoading = false
      }).catch(() => {
        this.oldOfferLoading = false
        this.editForm.totalprice = 0.0
        this.editForm.wall = 0.0
        this.editForm.cabinet = 0.0
        this.editForm.access = 0.0
        this.editForm.door = 0.0
        this.editForm.raise = 0.0
        this.editForm.discount = 0.0
        this.editForm.best = 0.0
        this.editForm.designcom = 0.0
        this.editForm.factorycom = 0.0
        this.editForm.clientcom = 0.0
        this.editForm.other = 0.0
        this.editForm.amount = 0.0
        this.editForm.offerOther = []
        this.editForm.aluminum = 0.0
        this.editForm.oil = 0.0
        this.editForm.tiepi = 0.0
        this.editForm.paint = 0.0
        this.editForm.changelst = []
        this.editForm.changes = 0.0
        this.editForm.content = ''
        this.editimgList = []
        this.editpubimgList = []
        this.editForm.rebateAmount = 0.0
        this.editForm.rebateSelection = []
        this.editForm.bjRebateList = []
        this.editForm.bjReportList = []
        this.editForm.bjTempList = []
        this.editForm.reportAmount = 0.0
        this.editForm.reportSelection = []
        this.imgLoad = new Date().getTime()
        this.pubimgLoad = new Date().getTime() + 1
      })
      this.bjfjActiveNames = ['1', '3']
      this.editVisible = true
    },
    countAmount() {
      let wall = 0.0
      let cabinet = 0.0
      let access = 0.0
      let door = 0.0
      let aluminum = 0.0
      if (this.editForm.wall !== null && this.editForm.wall !== '' && this.editForm.wall !== undefined) {
        wall = parseFloat(this.editForm.wall)
      }
      if (this.editForm.cabinet !== null && this.editForm.cabinet !== '' && this.editForm.cabinet !== undefined) {
        cabinet = parseFloat(this.editForm.cabinet)
      }
      if (this.editForm.access !== null && this.editForm.access !== '' && this.editForm.access !== undefined) {
        access = parseFloat(this.editForm.access)
      }
      if (this.editForm.door !== null && this.editForm.door !== '' && this.editForm.door !== undefined) {
        door = parseFloat(this.editForm.door)
      }
      if (this.editForm.aluminum !== null && this.editForm.aluminum !== '' && this.editForm.aluminum !== undefined) {
        aluminum = parseFloat(this.editForm.aluminum)
      }
      let amount = wall + cabinet + access + door + aluminum
      let raise = 0.0
      let best = 0.0
      if (this.editForm.raise !== null && this.editForm.raise !== '' && this.editForm.raise !== undefined) {
        raise = parseFloat(this.editForm.raise)
      }
      if (this.editForm.best !== null && this.editForm.best !== '' && this.editForm.best !== undefined) {
        best = parseFloat(this.editForm.best)
      }
      let other = 0.0
      if (this.editForm.other !== null && this.editForm.other !== '' && this.editForm.other !== undefined) {
        other = parseFloat(this.editForm.other)
      }
      let changes = 0.0
      if (this.editForm.changes !== null && this.editForm.changes !== '' && this.editForm.changes !== undefined) {
        changes = parseFloat(this.editForm.changes)
      }
      this.editForm.totalprice = (amount + raise + other + changes).toFixed(0)
      amount = amount + raise - best
      // et discount = 1
      // if (this.editForm.discount !== null && this.editForm.discount !== '' && this.editForm.discount !== undefined) {
      //   if (parseFloat(this.editForm.discount) > 0) {
      //     discount = parseFloat(this.editForm.discount) / 10
      //   }
      // }
      // amount = amount * discount
      amount = amount + other + changes
      if (this.editForm.refund > 0) {
        amount = amount - this.editForm.refund
      }
      if (amount < 0) {
        amount = 0.0
      }
      this.editForm.amount = amount.toFixed(0)
      this.UpperAmount = digitUppercase(this.editForm.amount)
    },
    bearAmount() {
      const amount = parseFloat(this.editForm.amount)
      let designcom = 0.0
      let factorycom = 0.0
      let clientcom = 0.0
      if (this.editForm.designcom !== null && this.editForm.designcom !== '' && this.editForm.designcom !== undefined) {
        if (parseFloat(this.editForm.designcom) >= 0) {
          designcom = parseFloat(this.editForm.designcom)
        }
      }
      if (this.editForm.factorycom !== null && this.editForm.factorycom !== '' && this.editForm.factorycom !== undefined) {
        if (parseFloat(this.editForm.factorycom) >= 0) {
          factorycom = parseFloat(this.editForm.factorycom)
        }
      }
      if (this.editForm.clientcom !== null && this.editForm.clientcom !== '' && this.editForm.clientcom !== undefined) {
        if (parseFloat(this.editForm.clientcom) >= 0) {
          clientcom = parseFloat(this.editForm.clientcom)
        }
      }
      if (factorycom < 0) {
        factorycom = 0
      }
      if (designcom < 0) {
        designcom = 0
      }
      clientcom = amount - factorycom - designcom
      if (clientcom < 0) {
        clientcom = 0
      }
      this.editForm.designcom = designcom
      this.editForm.factorycom = factorycom
      this.editForm.clientcom = clientcom.toFixed(2)
    },
    otherAmount() {
      let otheramount = 0.0
      for (let o of this.editForm.offerOther) {
        let amount = 0.0
        if (o.amount !== null && o.amount !== '' && o.amount !== undefined) {
          amount = parseFloat(o.amount)
        }
        otheramount = otheramount + amount
      }
      this.editForm.other = otheramount.toFixed(2)
    },
    importOffer() {
      if (!this.importloading) {
        this.importloading = true
        const importLoading = this.$loading({
          lock: true,
          text: '报价单正在解析中，请勿关闭此页面',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        })
        const data = {
          orderid: this.editForm.orderid,
          fileid: this.editForm.fileid,
          userid: this.user.dUserid
        }
        ErpOrderImportOffer(data).then(response => {
          this.editForm.totalprice = response.data.totalprice
          this.editForm.wall = response.data.wall
          this.editForm.cabinet = response.data.cabinet
          this.editForm.access = response.data.access
          this.editForm.door = response.data.door
          this.editForm.amount = response.data.totalprice
          this.editForm.aluminum = response.data.aluminum
          this.editForm.oil = response.data.oil
          this.editForm.tiepi = response.data.tiepi
          this.editForm.paint = response.data.paint
          this.getData()
          this.editForm.offerFileid = this.editForm.fileid
          this.importloading = false
          this.$message({
            message: '报价单解析成功',
            type: 'success'
          })
          importLoading.close()
        }).catch(() => {
          this.importloading = false
          importLoading.close()
        })
      }
    },
    addOther() {
      this.editForm.offerOther.push({ type: null, name: '', amount: null })
    },
    delOther(index) {
      this.editForm.offerOther.splice(index, 1)
    },
    turn(formName) {
      this.editRules.content[0].required = true
      this.editRules.fileid[0].required = false
      this.editRules.offerFileid[0].required = false
      this.editRules.qid[0].required = false
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.SubOfferOrder(0)
        } else {
          return false
        }
      })
    },
    subEdit(formName) {
      this.editRules.fileid[0].required = true
      this.editRules.offerFileid[0].required = true
      this.editRules.qid[0].required = true
      this.editRules.content[0].required = false
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let isok = true
          for (const rb of this.editForm.bjRebateList) {
            if (rb.ischeck) {
              if (rb.discountAmount === null || rb.discountAmount === '' || rb.discountAmount === undefined || parseFloat(rb.discountAmount) <= 0) {
                this.$message.error('请输入' + rb.name + '优惠金额')
                isok = false
                break
              } else {
                if (parseFloat(rb.discountAmount) > parseFloat(rb.balance)) {
                  this.$message.error(rb.name + '账户余额不足')
                  isok = false
                  break
                }
              }
            }
          }
          if (isok) {
            for (const rb of this.editForm.bjReportList) {
              if (rb.ischeck) {
                if (rb.currentDiscount === null || rb.currentDiscount === '' || rb.currentDiscount === undefined || parseFloat(rb.currentDiscount) <= 0) {
                  this.$message.error('请输入' + rb.name + '优惠折扣')
                  isok = false
                  break
                } else {
                  if (rb.discountAmount === null || rb.discountAmount === '' || rb.discountAmount === undefined || parseFloat(rb.discountAmount) <= 0) {
                    this.$message.error('请输入' + rb.name + '优惠金额')
                    isok = false
                    break
                  }
                }
              }
            }
          }
          if (isok) {
            for (const rb of this.editForm.bjTempList) {
              if (rb.ischeck) {
                if (rb.discountAmount === null || rb.discountAmount === '' || rb.discountAmount === undefined || parseFloat(rb.discountAmount) <= 0) {
                  this.$message.error('请输入' + rb.name + '优惠金额')
                  isok = false
                  break
                }
              }
            }
          }
          if (isok) {
            this.SubOfferOrder(1)
          }
        } else {
          return false
        }
      })
    },
    SubOfferOrder(ispass) {
      if (!this.editloading) {
        this.editloading = true
        const otherStr = qs.parse(this.editForm.offerOther)
        let rebateStr = []
        let reportStr = []
        let tempStr = []
        for (const rb of this.editForm.bjRebateList) {
          if (rb.ischeck) {
            rebateStr.push({ darid: rb.darid, amount: rb.discountAmount })
          }
        }
        for (const rb of this.editForm.bjReportList) {
          if (rb.ischeck) {
            reportStr.push({ darid: rb.darid, discount: rb.currentDiscount, amount: rb.discountAmount })
          }
        }
        for (const rb of this.editForm.bjTempList) {
          if (rb.ischeck) {
            tempStr.push({ datid: rb.datid, amount: rb.discountAmount })
          }
        }
        const data = {
          ispass: ispass,
          userid: this.user.dUserid,
          orderid: this.editForm.orderid,
          qid: this.editForm.qid.join(','),
          reason: this.editForm.content,
          imgStr: this.editForm.imgids.join(','),
          pubImgStr: this.editForm.pubimgids.join(','),
          totalprice: this.editForm.totalprice,
          wall: this.editForm.wall,
          cabinet: this.editForm.cabinet,
          access: this.editForm.access,
          door: this.editForm.door,
          raise: this.editForm.raise,
          discount: this.editForm.discount,
          best: this.editForm.best,
          designcom: this.editForm.designcom,
          factorycom: this.editForm.factorycom,
          clientcom: this.editForm.clientcom,
          other: this.editForm.other,
          changes: this.editForm.changes,
          amount: this.editForm.amount,
          otherStr: otherStr,
          aluminum: this.editForm.aluminum,
          tiepi: this.editForm.tiepi,
          oil: this.editForm.oil,
          paint: this.editForm.paint,
          jokins: this.editForm.jokins,
          yt: this.editForm.yt,
          rebateStr: qs.parse(rebateStr),
          reportStr: qs.parse(reportStr),
          tempStr: qs.parse(tempStr)
        }
        offerOrder(data).then(response => {
          let msg = '订单已报价成功'
          if (ispass === 0) {
            msg = '订单已驳回'
          }
          this.$message({
            message: msg,
            type: 'success'
          })
          this.editloading = false
          this.editVisible = false
          this.getData()
        }).catch(() => {
          this.editloading = false
        })
      } else {
        return false
      }
    },
    changeRecord(row) {
      this.changeRecordDialog = true
      this.changeRecordLoading = true
      getChangeOfferRecord({ orderid: row.order_id }).then(response => {
        this.changePriceData = response.data
        this.changeRecordLoading = false
      }).catch(() => {
        this.changeRecordLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dbj-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
